const JS_BUNDLE_SCRIPT      = document.getElementById('js_bundle_script');

const SERVER_URL            = (process.env.NODE_ENV == 'development' ? 'https://dev.secure-it.nl' : JS_BUNDLE_SCRIPT ? JS_BUNDLE_SCRIPT.dataset.datasource.split('/files/')[0] : '');
const IMAGES_URL            = SERVER_URL + '/files/images/';
const GLOBAL_IMAGES_URL     = 'https://beheer.secure-it.nl/files/images/';
const SERVER_REQUEST_URL    = SERVER_URL + '/files/javascripts/ajax_request.php';

export default {
  SERVER_URL,
  IMAGES_URL,
  SERVER_REQUEST_URL,
  GLOBAL_IMAGES_URL,
};